import React from 'react';

const Modal = (props) => {
  const { id, title } = props;
  return (
    <div className="modal fade" data-backdrop="static" tabIndex="-1" aria-hidden="true" id={id}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title || "Modal"}</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">{props.children}</div>
          <div className="modal-footer none">
            <button type="button" className="btn btn-secondary" data-dismiss="modal">닫기</button>
            {/* <button type="button" className="btn btn-primary">Understood</button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export { Modal };
